// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--B3Lpa"};